<template>
  <div>
    <table class="table table-hover table-sm mt-1">
      <thead>
      <tr>
        <th></th>
        <th>Курьер</th>
        <th>Адрес</th>
        <th>Запрос</th>
        <th>Текст</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(t,i) in list">
        <td>{{ i + 1 }}</td>
        <td>
          <p>{{ t.task_data.created_by_name }}</p>
          <p class="text-muted">{{ printDate(t.created_at) }} ({{ t.id }})</p>
        </td>
        <td>
          <p>{{ t.order.address }}</p>
          <p class="text-muted" v-if="t.order.extra_options.address_details">{{
              t.order.extra_options.address_details
            }}</p>
        </td>
        <td>
          <p>
            <button
              @click="orderToEdit(t.order_id)"
              class="btn btn-xs btn-info mr-1"
            >
              <i class="icon-fa icon-fa-eye"/>
            </button>
            {{ t.order_id }}
          </p>
          <p>установлено: <strong>{{ orderSalaryRates[t.task_data.old_value] }}</strong></p>
          <p>запрос: <strong>{{ orderSalaryRates[t.task_data.new_value] }}</strong></p>
        </td>
        <td>
          <div v-if="t.task_data.message" v-html="t.task_data.message"/>
        </td>
        <td>
          <div class="flex">
            <LoadingButton
              title='<i class="icon-fa icon-fa-check"></i>'
              className="btn btn-success btn-xs mr-1"
              :onClick="() => updateRequest(t.id, 'acceptAndClose')"
              :loading="btnLoading[t.id]"
              color="white"
            />
            <v-popover
              :auto-hide="true"
              placement="left"
            >
              <button class="btn btn-xs btn-danger">
                <i class="icon-fa icon-fa-close"></i>
              </button>
              <template slot="popover">
                <div class="p-2">
                  <div class="form-group">
                    <label for="">Причина отказа запроса</label>
                    <input placeholder="Причина отказа запроса" v-model="rejectComment[t.id]" type="text"
                           class="form-control">
                  </div>
                  <div class="text-right">
                    <LoadingButton
                      title='Подтвердить отказ'
                      className="btn btn-outline-warning btn-xs mr-1"
                      :onClick="() => updateRequest(t.id, 'rejectRequest')"
                      :loading="btnLoading[t.id]"
                      :color="$constants.WARNING_COLOR"
                    />
                  </div>
                </div>
              </template>
            </v-popover>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

import api from "@/api";
import LoadingButton from "@/components/buttons/LoadingButton";

export default {
  props: ['list', 'updateRecords', 'removeRecord'],
  components: {
    LoadingButton,
  },
  data() {
    return {
      btnLoading: {},
      rejectComment: {},
      orderSalaryRates: {
        0: 'низкая ставка',
        1: 'высокая ставка',
        2: 'дальняя ставка',
      },
    }
  },
  methods: {
    async updateRequest(id, action) {
      this.btnLoading[id] = true;
      this.btnLoading = {...this.btnLoading};
      const {data} = await api.post('/tasks/' + id, {
        action: action,
        comment: this.rejectComment[id],
      })
      if (data.success) {
        if (this.removeRecord) {
          this.removeRecord(id);
        }
        toastr['success'](data.message || 'Обновлено', 'Успешно!')
      } else {
        toastr['warning'](data.message, 'Ошибка!')
      }
      this.btnLoading[id] = false;
    },
    orderToEdit(id, dialog = null) {
      this.$store.dispatch('orders/setOrderToEdit', {orderId: id});
    },
  }
}

</script>
